<template>
  <component
    :is="isMobile ? 'div' : Primitive"
    :class="isMobile ? 'px-5 pb-5 flex flex-col gap-5' : undefined"
  >
    <div
      class="flex"
      :class="isMobile ? 'items-start gap-3' : 'p-4 flex-col gap-2'"
    >
      <div class="flex items-center gap-2 text-[15px] font-bold text-foreground">
        <span
          class="flex items-center justify-center rounded-ds-md bg-warning-subtle text-warning-subtle-foreground shrink-0"
          :class="isMobile ? 'size-10' : 'size-7'"
        >
          <ZapIcon
            :class="isMobile ? 'size-5' : 'size-3.5'"
            aria-hidden="true"
          />
        </span>
        <template v-if="!isMobile">
          Power mode is on
        </template>
      </div>
      <p
        class="leading-relaxed text-muted-foreground text-pretty"
        :class="isMobile ? 'text-[15px]' : 'text-[13px]'"
      >
        Power mode lets you perform irreversible actions. For safety, turn it off when you don't need it. You can turn it back on anytime in Settings.
      </p>
    </div>
    <div
      class="flex gap-2"
      :class="isMobile ? 'flex-col-reverse' : 'px-4 py-3 justify-end border-t border-border'"
    >
      <DSButton
        variant="ghost"
        :size="isMobile ? 'lg' : 'sm'"
        :class="isMobile ? 'w-full' : undefined"
        @click="emit('close')"
      >
        Keep on
      </DSButton>
      <DSButton
        variant="primary"
        :size="isMobile ? 'lg' : 'sm'"
        :class="isMobile ? 'w-full' : undefined"
        @click="handleTurnOff"
      >
        Turn off power mode
      </DSButton>
    </div>
  </component>
</template>

<script setup lang="ts">
import { Primitive } from 'reka-ui'

import { useSettingsStore } from '@/store/settings'

import { DSButton } from '@ds'
import { ZapIcon } from '@lucide/vue'

defineProps<{
  isMobile?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const settingsStore = useSettingsStore()

const handleTurnOff = () => {
  settingsStore.setPowerMode(false)
}
</script>
